module.exports = __webpack_public_path__ + "img/bagging-list.5df45d63.svg";